import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import InputPasswordModal from "./components/modal/InputPasswordModal"
import ReportBuilder from "../ReportBuilder/ReportBuilderLayout/ReportBuilder"

const DashboardReport = function () {
    const { password: passwordValue } = useSelector((state) => state.dashboardReport);
    const [showPasswordfield, setShowPasswordfield] = useState(false);

    useEffect(() => {
        if (!passwordValue) {
            setShowPasswordfield(true);
        }
    }, [passwordValue]);

    return (
        <div
            className="dashboardreport-container"
            style={{
                height: "calc(100% - 8mm)", width: "100%", padding: "4mm 6mm", overflowY: "auto", backgroundColor: "var(--coolgray-50)"
            }}
        >
            {passwordValue && <ReportBuilder />}
            {showPasswordfield && <InputPasswordModal visible={showPasswordfield} onClose={setShowPasswordfield} />}
        </div>
    );
};

export default DashboardReport;
